import styled from "styled-components";

const MobileRewardsWrapper = styled.div`
  padding-top:1rem;
  background ${props => props.theme.backgrounds.mainBG};
`;

export default MobileRewardsWrapper;
